import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Parser from 'html-react-parser';

const NotificationTextCollection = ({ collection }) => (
  <>
    {collection.uuid ? (
      <Link to={`/collections/${collection.uuid}`}>
        {Parser(`<strong>${collection.name || ''}</strong>`)}
      </Link>
    ) : (
      Parser(`<strong>${collection.name || ''}</strong>`)
    )}
  </>
);

NotificationTextCollection.propTypes = {
  collection: PropTypes.object,
};

NotificationTextCollection.defaultProps = {
  collection: {
    name: '(deleted collection)',
  },
};

export default NotificationTextCollection;
